export const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
export const API_PORTAL_URL = process.env.NEXT_PUBLIC_PORTAL_URL;
export const RAZORPAY_KEY_ID = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID;

/**
 * Common configuration for international customer price hike (e.g. 15 for 15% hike).
 * Can be easily adjusted here or configured via NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT env variable.
 */
export const INTERNATIONAL_PRICE_HIKE_PERCENT =
  process.env.NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT !== undefined
    ? Number(process.env.NEXT_PUBLIC_INTERNATIONAL_PRICE_HIKE_PERCENT)
    : 15;
